import React, { Component } from "react";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";

export default class SpeechNote extends Component {
  render() {
    return (
      <>
        <h6 style={{ marginBottom: 5, fontSize: 18 }}>Note:</h6>
        <br />
        <div className="d-flex bottom-instructions" style={{ marginLeft: -7 }}>
          <div className="item">
            <div className="participant-icon">C</div> &nbsp;&nbsp;&nbsp; =
            Controls
          </div>
          <div className="item">
            <div className="participant-icon">ALS</div> &nbsp;&nbsp;&nbsp; = ALS
          </div>
        </div>
        <hr />
        <h6 style={{ marginBottom: 5, fontSize: 18 }}>
          Last Session Date Color Explanation Note:
        </h6>
        <br />
        <div className="d-flex bottom-instructions" style={{ marginLeft: -7 }}>
          <div className="item">
            <div
              className="participant-icon"
              style={{
                background: "#adf7b6",
                boxShadow: "none",
                border: "1px solid #000",
              }}
            ></div>{" "}
            &nbsp;&nbsp;&nbsp; = Last Session Recorded In 4 Weeks.
          </div>
          <div className="item">
            <div
              className="participant-icon"
              style={{
                background: "#ffee93",
                boxShadow: "none",
                border: "1px solid #000",
              }}
            ></div>{" "}
            &nbsp;&nbsp;&nbsp; = Last Session Recorded In 4 to 8 Weeks.
          </div>
          <div className="item">
            <div
              className="participant-icon"
              style={{
                background: "#ffc09f",
                boxShadow: "none",
                border: "1px solid #000",
              }}
            ></div>{" "}
            &nbsp;&nbsp;&nbsp; = Last Session Is Not Recorded From 8 Weeks.
          </div>
        </div>
      </>
    );
  }
}
